// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5iDMl","links":"styles_links__3cK47","menu":"styles_menu__3UHXz","menuWrapper":"styles_menuWrapper__WfwWZ","icon":"styles_icon__L1-0s"};